import { types } from '../types';

const asArray = (payload: unknown): any[] =>
    Array.isArray(payload) ? payload : [];

const initialState = {
    statusList: [] as Array<any>,
    channelList: [] as Array<any>,
    logUser: undefined,
    blockPagesList: [] as Array<undefined>,
    listQuestionDependency: [] as Array<any>,
    activeStep: 0,
    ipOrigin: '',
};

export const generalReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case types.uploadStatus:
            return {
                ...state,
                statusList: asArray(action.payload),
            };

        case types.uploadChannels:
            return {
                ...state,
                channelList: asArray(action.payload),
            };

        case types.uploadUserLog:
            return {
                ...state,
                logUser: { ...action.payload },
            };

        case types.nextStepper:
            return {
                ...state,
                activeStep: state.activeStep + 1,
            };

        case types.backStepper:
            return {
                ...state,
                activeStep: state.activeStep - 1,
            };

        case types.resetStepper:
            return {
                ...state,
                activeStep: initialState.activeStep,
            };

        case types.blockPages:
            return {
                ...state,
                blockPagesList: asArray(action.payload),
            };

        case types.uploadIpOrigin:
            return {
                ...state,
                ipOrigin: action.payload,
            };

        case types.questionDependency:
            return {
                ...state,
                listQuestionDependency: asArray(action.payload),
            };

        case types.logoutLogin:
            return {
                ...state,
                logUser: undefined,
                blockPages: undefined,
                statusList: [],
                channelList: [],
                activeStep: 0,
                ipOrigin: '',
                listQuestionDependency: [],
            };

        default:
            return state;
    }
};
